// Keep weights synchronized with https://static.bombbomb.com/fonts/inter.css
const fontSmoothing = `
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
`;
const fontFamily = "font-family: 'Inter var', Arial, Helvetica, Avenir, sans-serif;";

/**
 * Return the font closure
 */
const inter =
  (weight: number, style: 'normal' | 'italic' = 'normal') =>
  () =>
    `
  ${fontSmoothing}
  ${fontFamily}
  font-style: ${style};
  font-synthesis: style;
  font-weight: ${weight};
`;

/**
 * Inter weight 100
 */
const thin = inter(100);

/**
 * Inter weight 100, italic
 */
const thinItalic = inter(100, 'italic');

/**
 * Inter weight 200
 */
const extraLight = inter(200);

/**
 * Inter weight 200, italic
 */
const extraLightItalic = inter(200, 'italic');

/**
 * Inter weight 300
 */
const light = inter(300);

/**
 * Inter weight 300, italic
 */
const lightItalic = inter(300, 'italic');

/**
 * Inter weight 400
 */
const regular = inter(400);

/**
 * Inter weight 400, italic
 */
const regularItalic = inter(400, 'italic');

/**
 * Inter weight 500
 */
const medium = inter(500);

/**
 * Inter weight 500, italic
 */
const mediumItalic = inter(500, 'italic');

/**
 * Inter weight 600
 */
const semiBold = inter(600);

/**
 * Inter weight 600, italic
 */
const semiBoldItalic = inter(600, 'italic');

/**
 * Inter weight 700
 */
const bold = inter(700);

/**
 * Inter weight 700, italic
 */
const boldItalic = inter(700, 'italic');

/**
 * Inter weight 800
 */
const extraBold = inter(800);

/**
 * Inter weight 800, italic
 */
const extraBoldItalic = inter(800, 'italic');

/**
 * Inter weight 900
 */
const black = inter(900);

/**
 * Inter weight 900, italic
 */
const blackItalic = inter(900, 'italic');

export {
  thin,
  thinItalic,
  extraLight,
  extraLightItalic,
  light,
  lightItalic,
  regular,
  regularItalic,
  medium,
  mediumItalic,
  semiBold,
  semiBoldItalic,
  bold,
  boldItalic,
  extraBold,
  extraBoldItalic,
  black,
  blackItalic,
};
